<ng-template #content let-c="close" let-d="dismiss">

  <div class="modal-header">
    <h5 class="modal-title" id="modal-basic-title">{{title}}</h5>
    <button type="button" class="close" [attr.aria-label]="cancelButton" (click)="d('cancel')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <ng-template [ngTemplateOutlet]="body"></ng-template>
  </div>

  <div *ngIf="showFooter" class="modal-footer">
    <!-- neutral -->
    <button *ngIf="showCancel" type="button" class="btn btn-secondary" (click)="d('cancel')">{{cancelButton}}</button>
    <!-- negative -->
    <button *ngIf="showNegative" type="button" class="btn btn-danger" (click)="d('negative')">{{negativeButton}}</button>
    <!-- positive -->
    <button *ngIf="showPositive" type="button" [disabled]="positiveButtonDisabled" class="btn btn-primary" (click)="c('cancel')">{{positiveButton}}</button>
  </div>

</ng-template>